import { z } from 'zod'

// PSP Response Data Schema
export const pspResponseData = z.object({
    pspProfileId: z
        .string()
        .max(100)
        .describe('The link to the PSP profile in the third party vault'),
    pspSystem: z.string().max(100).optional().default('PAYSAFE'),
    pspToken: z.string().max(100),
    pspNetworkToken: z.string().max(100).optional().describe('NOT USED'),
    pspId: z
        .string()
        .max(100)
        .describe(
            'The id of the actual thing thats contain within the vault profile',
        ),
})
